import { render } from "./AdminNavBar.vue?vue&type=template&id=64a95a68"
import script from "./AdminNavBar.vue?vue&type=script&lang=js"
export * from "./AdminNavBar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\User\\Desktop\\doc\\MedRemind Project\\medremind-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__